// extracted by extract-css-chunks-webpack-plugin
module.exports = {"input":"Input__input","input__inline":"Input__input__inline","label":"Input__label","label_text":"Input__label_text","label__error":"Input__label__error"};